"use strict";

$(() => {
  const iframe = document.getElementById('SuppliesOverviewIframe');
  if (iframe) {
    console.log('iframe');
    iframe.onload = () => {
      console.log('onload');
      const body = iframe.contentDocument.body;
      iframe.style.height = body.offsetHeight + 'px';
      console.log('resize-initial');
      const observer = new MutationObserver(function () {
        console.log('resize-by-observer');
        iframe.style.height = body.offsetHeight + 'px';
      });
      observer.observe(body, {
        attributes: true,
        childList: true,
        subtree: true
      });
    };
  }
});